export default "__VITE_ASSET__nECJFrsr__"